import styled from 'styled-components'

export default styled.article`
  width: 800px;
  border-radius: 4px;
  background-color: ${ ({ theme }) => theme.colors.white };
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
  height: 100%;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1;
  margin: 50px;
  padding: 50px;

  img.check {
    width: 70px;
    height: 70px;
    margin-bottom: 30px;
  }

  h3 {
    font-size: 20px;
    margin-bottom: 10px;
    text-align: center;
  }

  p {
    font-size: 16px;
    color: ${ ({ theme }) => theme.colors.grey };
    margin-bottom: 40px;
    text-align: center;
  }

  .acceptButton {
    width: max-content;
    padding: 20px 40px;
  }

  @media screen and (max-width: 768px){
    width: 100%;
    margin: 0;
    overflow: auto;
    padding: 30px;
  }
`
